import React from "react"
import { Loading } from "@bancacfplus/Loading"
import style from "./Loader.module.scss"

export const Loader: React.FC<{ fullPage?: boolean }> = ({ fullPage = false }) => {
  return fullPage ? (
    <div className={style.containerFullPage}>
      <Loading />
    </div>
  ) : (
    <div className={style.container}>
      <Loading />
    </div>
  )
}
